import { render, staticRenderFns } from "./ModalConfirm.vue?vue&type=template&id=363b97da&scoped=true"
import script from "./ModalConfirm.vue?vue&type=script&lang=js"
export * from "./ModalConfirm.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirm.vue?vue&type=style&index=0&id=363b97da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363b97da",
  null
  
)

export default component.exports